import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const RETURNS_API_PATH = '/api/returns-to-supplier';

export const createReturn = async (payload) => {
  const response = await axios.post(`${API_BASE_URL}${RETURNS_API_PATH}`, payload);
  return response.data;
};

export const listReturns = async (storeId) => {
  const response = await axios.get(`${API_BASE_URL}${RETURNS_API_PATH}`, { params: { storeId } });
  return response.data;
};

const getReturnReport = async (params = {}) => {
  const response = await axios.get(`${API_BASE_URL}${RETURNS_API_PATH}/report`, { params });
  return response.data;
};

const returnsToSupplierService = {
  createReturn,
  listReturns,
  getReturnReport,
};

export default returnsToSupplierService;
